import request from "@/utils/request";
const index = {
  // 列表
  list(query) {
    return request({
      url: "/allfamilymember/list",
      method: "get",
      params: query
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/allfamilymember/detail",
      method: "post",
      params: query
    });
  },
  // 待审核列表
  reviewList(query) {
    return request({
      url: "/allfamilymember/reviewList",
      method: "get",
      params: query
    });
  },
  // 详情
  review(query) {
    return request({
      url: "/allfamilymember/review",
      method: "post",
      params: query
    });
  },
  // 修改
    edit(data) {
        return request({
        url: "/allfamilymember/edit",
        method: "post",
        data
        });
    },
};
export default index;